export const GET_SURVEY_FEEDBACK_REQUEST_SENT = 'src/patientApp/SurveyFeedback/GET_SURVEY_FEEDBACK_REQUEST_SENT';
export const GET_SURVEY_FEEDBACK_REQUEST_SUCCEED = 'src/patientApp/SurveyFeedback/GET_SURVEY_FEEDBACK_REQUEST_SUCCEED';
export const GET_SURVEY_FEEDBACK_REQUEST_FAILED = 'src/patientApp/SurveyFeedback/GET_SURVEY_FEEDBACK_REQUEST_FAILED';

export const SUBMIT_SURVEY_FEEDBACK_REQUEST_SENT = 'src/patientApp/SurveyFeedback/SUBMIT_SURVEY_FEEDBACK_REQUEST_SENT';
export const SUBMIT_SURVEY_FEEDBACK_REQUEST_SUCCEED = 'src/patientApp/SurveyFeedback/SUBMIT_SURVEY_FEEDBACK_REQUEST_SUCCEED';
export const SUBMIT_SURVEY_FEEDBACK_REQUEST_FAILED = 'src/patientApp/SurveyFeedback/SUBMIT_SURVEY_FEEDBACK_REQUEST_FAILED';

export const CLEAR_SURVEY_FEEDBACK_QUESTIONS = 'src/patientApp/SurveyFeedback/CLEAR_SURVEY_FEEDBACK_QUESTIONS';
